
import React, {Component} from 'react'
import {connect} from "react-redux";

import Loader from 'react-loader-spinner';

class Loading extends Component {


    render() {
        return (
            <div className="spinner">
                <Loader
                    type="ThreeDots"
                    color="#6d5c3a"
                    height="100"
                    width="100"
                />
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Loading);